import { RouteRecordRaw } from 'vue-router';
import { invitedSitterTokenGuard } from '@/router/guards/backupCareGuards';

const backupCareInviteRoutes: RouteRecordRaw[] = [
  {
    path: '/backup-care/:interview_request_id/invite/:invited_sitter_id/:invited_sitter_token',
    name: 'backup-care-invited-sitter-token',
    meta: { skipAuth: true },
    beforeEnter: invitedSitterTokenGuard,
    // The guard redirects every visitor; Vue Router still requires a route component.
    component: { render: () => null },
  },
];

export default backupCareInviteRoutes;
